// extracted by mini-css-extract-plugin
export default {"undoButton":"UndoButton_undoButton__d9nC8","iconWrap":"UndoButton_iconWrap__mxoFq"};